/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


/*
* Refresh Plan (subscription) free shipping message fix
*
* Pipeline's built-in CartShippingMessage component (assets/theme.js) recalculates the
* free shipping "is-success" state and progress wheel purely from the cart subtotal every
* time a "theme:cart:change" event fires (on page load via onpageshow, and after cart
* mutations). It has no awareness of subscriptions, so it strips the server-rendered
* "Free shipping included with your Refresh Plan" state whenever a Refresh Plan order's
* subtotal is below the one-time-purchase free shipping threshold — regardless of what
* order event listeners happen to run in.
*
* Rather than race theme.js for the last word on a shared event, this watches the
* server-rendered `data-cart-has-subscription` attribute (set by
* snippets/cart-shipping-message.liquid purely from Shopify's own selling plan data on
* the cart's line items — no hardcoded product names, handles, variants or prices) on
* each shipping message element, and immediately re-applies the success state any time
* theme.js's own logic removes it. It also watches for the shipping message markup
* being replaced outright (e.g. the cart drawer re-rendering its contents), so a
* Refresh Plan message is corrected wherever it appears, without touching theme.js or
* the one-time-purchase threshold logic.
*/
(function() {
  function applyFix(el) {
    if (el.getAttribute('data-cart-has-subscription') !== 'true') {
      return;
    }

    if (!el.classList.contains('is-success')) {
      el.classList.add('is-success');
    }

    var scope = el.closest ? (el.closest('.cart__message-wrapper') || el.parentNode || document) : document;
    scope.querySelectorAll('[data-cart-progress]').forEach(function(circle) {
      var circumference = 28 * Math.PI;
      circle.style.strokeDashoffset = circumference - circumference / 2;
    });
  }

  function watch(el) {
    if (el.__refreshPlanShippingObserved) {
      return;
    }
    el.__refreshPlanShippingObserved = true;

    var observer = new MutationObserver(function() {
      applyFix(el);
    });
    observer.observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    document.querySelectorAll('[data-cart-message][data-cart-has-subscription="true"]').forEach(function(el) {
      applyFix(el);
      watch(el);
    });
  }

  // Re-run whenever the theme announces a cart change (add/update/remove, and the
  // onpageshow-driven dispatch that fires on every full page load).
  document.addEventListener('theme:cart:change', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also watch for the shipping message markup itself being replaced wholesale
  // (e.g. a cart drawer re-render), so a freshly-inserted Refresh Plan message is
  // picked up even outside a "theme:cart:change" event.
  var bodyObserver = new MutationObserver(function(mutations) {
    var shouldInit = false;
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) {
          return;
        }
        if ((node.matches && node.matches('[data-cart-message]')) ||
            (node.querySelector && node.querySelector('[data-cart-message]'))) {
          shouldInit = true;
        }
      });
    });
    if (shouldInit) {
      init();
    }
  });
  bodyObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
